"use client";
import React, { useEffect, useRef, useState } from "react";
import {
  IoClose,
  IoSend,
  IoImage,
  IoMic,
  IoLocationSharp,
  IoHappyOutline,
} from "react-icons/io5";
import { useSocket } from "./SocketProvider";
import { useSelector } from "react-redux";
import moment from "moment";
import Messages from "./Messages";
import ReactScrollToBottom from "react-scroll-to-bottom";
import EmojiPicker from "emoji-picker-react";
import { RxCross2 } from "react-icons/rx";
import { FaPlus } from "react-icons/fa";
import { ImageDisplay } from "./ImageDisplay";
import "./style.css";

const ChatComponent = ({ data, onClose }) => {
  const {
    socket,
    setMessage,
    message,
    handleMessage,
    setReceiverUID,
    receiverUID,
    allMessages,
    setFiles,
    setPreview,
    isImageModalOpen,
    isLoading,
    progress,
    setIsImageModalOpen,
    file,
    preview,
    setOrderId,
    orderId,
  } = useSocket();
  const activeUser = useSelector((state) => state.store.currentUser);
  const [typing, setTyping] = useState(false);
  const [typingUser, setTypingUser] = useState("");
  const [isEmojiPickerVisible, setIsEmojiPickerVisible] = useState(false);

  useEffect(() => {
    setOrderId(data?.orderDetails?.[0]?.order);
  }, [data]);

  useEffect(() => {
  if (socket && activeUser?._id && receiverUID && orderId) {
    socket.emit("single-user-msgs", {
      senderId: activeUser._id,
      receiverId: receiverUID,
      orderId,
    });
  }
}, [socket, activeUser?._id, receiverUID, orderId]);


  const handleEmojiClick = (event, emojiObject) => {
    setIsEmojiPickerVisible(false);
    setMessage(event.emoji);
  };

  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedImages = Array.from(e.target.files);
    setFiles((prevImages) => [...prevImages, ...selectedImages]);

    // This is the process where i convert the file into image to show in the frontend side
    const readFiles = selectedImages.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles).then((newPreviews) => {
      setPreview((prevPreviews) => [...prevPreviews, ...newPreviews]);
      setIsImageModalOpen(true);
    });

    e.target.value = null;
  };

  const groupMessagesByDate = (messages) => {
    return messages.reduce((groupedMessages, message) => {
      const date = new Date(message.created_at);
      const today = moment().startOf("day");
      const messageDate = moment(date).startOf("day");
      let dateKey;

      if (messageDate.isSame(today, "day")) {
        dateKey = "Today";
      } else if (messageDate.isSame(today.clone().subtract(1, "day"), "day")) {
        dateKey = "Yesterday";
      } else if (messageDate.isSame(today, "week")) {
        dateKey = messageDate.format("dddd");
      } else {
        dateKey = messageDate.format("DD MMMM YYYY");
      }

      if (!groupedMessages[dateKey]) {
        groupedMessages[dateKey] = [];
      }
      groupedMessages[dateKey].push(message);

      return groupedMessages;
    }, {});
  };

  // This groupedMessages function filter the messages according to the receiver and sender
  const groupedMessages = groupMessagesByDate(
    allMessages.filter(
      (item) =>
        (item.order_id === orderId &&
          item.receiver_id?._id === receiverUID &&
          item.sender_id?._id === activeUser?._id) ||
        (item.order_id === orderId &&
          item.sender_id?._id === receiverUID &&
          item.receiver_id?._id === activeUser?._id)
    )
  );

  const messagesWithDates = [];

  // Here groupedMessages are object like date : [messages] to convert in the one array we did this
  Object.entries(groupedMessages).forEach(([date, messages]) => {
    messagesWithDates.push({ type: "date", date });
    messages.forEach((message) => {
      messagesWithDates.push({ type: "message", ...message });
    });
  });

  const handleTyping = () => {
    const senderId = activeUser?._id;
    const receiverId = receiverUID;
    socket.emit("typing", { sender: senderId, receiver: receiverId, orderId });
  };

  useEffect(() => {
    socket.on("typing", (data) => {
      if (data.receiver === activeUser?._id && data.orderId === orderId) {
        setTypingUser(data.user);
        if (orderId === data.orderId) {
          setTyping(true);
        } else {
          setTyping(false);
        }
        setTimeout(() => setTyping(false), 5000);
      }
    });

    return () => {
      socket.off("typing");
    };
  }, [activeUser.id, socket, activeUser, orderId]);

  console.log(("data",data));
  

  useEffect(() => {
    setReceiverUID(data?.created_by?._id);
  }, [data]);

  return (
    <div className="flex flex-col justify-between h-[95%] relative shadow-md  rounded  w-full mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b">
        <div className="flex flex-col items-start justify-start w-full">
          <h2 className="text-lg font-semibold capitalize">
            {data?.delivery_address?.name} {"  "} ({data?.order_id})
          </h2>

          <span className="text-sm text-blue600 font-semibold">
            {typing && "Typing....."}
          </span>
        </div>
        <button onClick={onClose} className="text-[#4A5568] hover:text-red600">
          {onClose && <IoClose size={24} />}
        </button>
      </div>

      {!isImageModalOpen ? (
        messagesWithDates.length > 0 ? (
          <ReactScrollToBottom className="h-[90vh] p-4 overflow-auto w-full relative">
            {messagesWithDates.map((item, ind) => {
              if (item.type === "date") {
                return (
                  <Messages
                    key={ind}
                    user="date"
                    message={item.date}
                    classs="message_message-date"
                  />
                );
              } else if (item.file) {
                return (
                  <Messages
                    key={ind}
                    message={item.file}
                    time_date={item.created_at}
                    classs={
                      item.sender_id?._id === receiverUID
                        ? "message_left"
                        : "message_right"
                    }
                    file={true}
                  />
                );
              } else {
                return (
                  <Messages
                    key={ind}
                    user={
                      item.sender_id?._id === receiverUID
                        ? ""
                        : activeUser?.full_name
                    }
                    message={item.message}
                    time_date={item.created_at}
                    classs={
                      item.sender_id?._id === receiverUID
                        ? "message_left"
                        : "message_right"
                    }
                  />
                );
              }
            })}

            {/* Loading State */}
            {isLoading &&
              progress &&
              preview.map((src, index) => (
                <Messages
                  key={index}
                  isLoading={isLoading}
                  progress={progress}
                  message={src}
                  classs="right"
                />
              ))}
          </ReactScrollToBottom>
        ) : (
          <div className="h-[90vh] flex flex-col items-center justify-center bg-gray-50 rounded-md shadow-inner">
            <p className="text-[#6B7280] text-lg font-medium mb-2">
              No conversations yet
            </p>
            <p className="text-sm text-gray-400 italic">
              Start a new conversation and your messages will appear here!
            </p>
          </div>
        )
      ) : (
        <section className="file__modal__container">
          <i>
            <RxCross2
              onClick={() => {
                setIsImageModalOpen(false);
                setFiles([]);
                setPreview([]);
              }}
            />
          </i>
          <div className="file__name__img">
            <span>{file?.name || "No File Selected"}</span>
            <div className="image__display">
              {file?.map((image, index) => (
                <div key={index} className="images__storing__container">
                  <ImageDisplay
                    image={image}
                    setFiles={setFiles}
                    index={index}
                    setPreview={setPreview}
                  />
                </div>
              ))}
            </div>
          </div>
          <section className="multiple__images__add__remove">
            <label htmlFor="attachment" className="multiple__images__add">
              <FaPlus />
            </label>
          </section>
        </section>
      )}

      {/* Input Area */}
      <div className="pb-10 pt-6 pl-2 border-t bg-gray-100 flex items-center space-x-3">
        <button className="text-[#6B7280] hover:text-blue500">
          <IoMic size={24} />
        </button>
        <div className="flex-1 relative">
          <input
            type="text"
            placeholder="Type a message"
            className="w-full rounded-full border border-gray-300 bg-white px-4 py-2 pl-10 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue500"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              handleTyping();
            }}
            onKeyDown={(e)=>{
              if (e.key.toLowerCase()==='enter') {
                handleMessage()
              }
            }}
          />
          <IoHappyOutline
            size={20}
            onClick={() => setIsEmojiPickerVisible((prev) => !prev)}
            className="absolute top-1/2 transform -translate-y-1/2 left-1 cursor-pointer text-gray-400"
          />
        </div>

        {isEmojiPickerVisible && (
          <div className="absolute bottom-12 left-0 z-10">
            <EmojiPicker onEmojiClick={handleEmojiClick} />
          </div>
        )}

        <div>
          <button className="text-[#6B7280] hover:text-blue500 pt-2">
            <IoImage size={24} onClick={() => fileInputRef.current.click()} />
          </button>
          <input
            ref={fileInputRef}
            type="file"
            id="attachment"
            className="hidden"
            multiple
            onChange={handleFileChange}           
          />
        </div>

        <button className="text-[#6B7280] hover:text-blue500">
          <IoLocationSharp size={24} />
        </button>
        <button
          className="text-RedColor hover:text-blue700"
          onClick={handleMessage}
        >
          <IoSend size={24} />
        </button>
      </div>
    </div>
  );
};

export default ChatComponent;
